import React from 'react'

import AuthManager from '../utils/AuthManager'

import CRMEngagementCard from './components/cards/CRMEngagementCard'
import CRMBoard from './components/board/CRMBoard'
import Switch from "react-switch";
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import SubmissionsTable from "./components/tables/SubmissionsTable";


export default class Contacts extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      tableView: false,
    }
  }

  render() {

    let {
      tableView,
    } = this.state

    return (
      <div className="text-center c-tabs">
        <Tabs
          defaultActiveKey="kanban"
          id="noanim-tab-example"
          variant="pills"
        >
          <Tab eventKey="kanban" title="List View">
            <div className="text-left">
              <CRMBoard/>
            </div>
          </Tab>
          <Tab eventKey="table" title="Table View">
            <div className="row text-left px-25 mt-25px">
              <SubmissionsTable crm={true}/>
            </div>
          </Tab>
        </Tabs>
      </div>
    )

  }
}
